import { FiAlertCircle } from "react-icons/fi";

interface IProps {
    message: string | Record<string, any> | undefined;
}

const FormFieldError: React.FC<IProps> = ({ message }) => {
    if (!message) return null;
    return (
        <div className="invalid-feedback d-inline-flex align-items-center">
            <FiAlertCircle className="me-1" />
            <span>{(message as string) || ""}</span>
        </div>
    );
};

export default FormFieldError;
